/*
  RigStrips: strip savings messages.
  The "Buy more, save more" tiers (10% / 15% / 20% off 2 / 3 / 4+ strips) are Shopify
  automatic discounts, so they apply everywhere (cart, checkout, Shop Pay, Apple Pay) and
  Shopify keeps whichever discount saves the customer the most. This script never changes
  discount codes; it only shows the savings messages:
  - product page: the line under the mount switcher ([data-rs-strip-nudge])
  - cart drawer + cart page: a progress bar toward the next tier
  To change which products count as strips, edit HANDLES. Tier amounts live in Shopify > Discounts.
*/
(function () {
  if (window.RsTiers) return;
  var HANDLES = ['snostrip-magnetic', 'sunstrip', 'snostrip-adhesive', 'rigstrip-suction-cup'];
  var OLD_TIER_CODES = ['2prod', '3prod', '4+prod'];
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch.bind(window);
  var timer = null;

  // Clean up storage left by the earlier code-swapping version of this script.
  try { localStorage.removeItem('rs_parked_codes'); sessionStorage.removeItem('rs_best_deal_sig'); } catch (e) {}

  function lc(c) { return String(c).toLowerCase(); }
  function isTierCode(c) { return OLD_TIER_CODES.indexOf(lc(c)) > -1; }

  function check() {
    origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(updateMessages)
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, 400);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (CART_CHANGE.test(url.split('#')[0])) p.then(schedule, function () {});
    return p;
  };

  /* ---- Strip savings messages ---- */
  var STEPS = [{ n: 2, pct: 10 }, { n: 3, pct: 15 }, { n: 4, pct: 20 }];
  var stripN = null;
  var otherApplied = '';
  var note = '';

  function countStrips(cart) {
    var n = 0;
    cart.items.forEach(function (i) { if (HANDLES.indexOf(i.handle) > -1) n += i.quantity; });
    return n;
  }
  function pctFor(n) {
    var p = 0;
    STEPS.forEach(function (s) { if (n >= s.n) p = s.pct; });
    return p;
  }
  function nudgeHtml(n) {
    if (n <= 0) return '<strong>Buy more, save more:</strong> 2 strips 10% · 3 strips 15% · 4+ strips 20% off. Mix and match.';
    if (n >= 4) return 'You’re saving <strong>20%</strong> on the ' + n + ' strips in your cart. Every strip you add saves 20% too.';
    var words = n === 1 ? 'both' : 'all ' + (n + 1);
    return 'You have ' + n + ' strip' + (n > 1 ? 's' : '') + ' in your cart. <strong>Add this one and save ' + pctFor(n + 1) + '% on ' + words + '.</strong>';
  }
  function progressHtml(n) {
    var msg;
    if (n >= 4) {
      msg = 'You’re saving <strong>20%</strong> on your strips.';
    } else {
      var next = STEPS.filter(function (s) { return s.n > n; })[0];
      var need = next.n - n;
      var cur = pctFor(n);
      msg = 'Add ' + need + ' more strip' + (need > 1 ? 's' : '') + ' to save <strong>' + next.pct + '%</strong>' +
        (cur && !otherApplied ? ' <span class="rs-sp__now">(saving ' + cur + '% now)</span>' : '');
    }
    if (n >= 4 && otherApplied) msg = 'Your code <strong>' + otherApplied + '</strong> is giving you the best price.';
    if (note) msg += '<span class="rs-sp__note">' + note + '</span>';
    var marks = STEPS.map(function (s) {
      return '<i class="rs-sp__mark' + (n >= s.n ? ' is-on' : '') + '" style="left:' + (s.n / 4 * 100) + '%"><b>' + s.pct + '%</b></i>';
    }).join('');
    return '<p class="rs-sp__msg">' + msg + '</p><div class="rs-sp__bar"><span class="rs-sp__fill" style="width:' + (Math.min(n, 4) / 4 * 100) + '%"></span>' + marks + '</div>';
  }

  var CSS = '.rs-sp{padding:12px 16px 30px;margin-bottom:14px;border-bottom:1px solid rgba(var(--color-foreground),.1);font-size:1.3rem;line-height:1.4}' +
    '.rs-sp--page{padding:14px 0 30px;margin-bottom:8px;border-bottom:0}' +
    '.rs-sp__msg{margin:0 0 10px}.rs-sp__now{opacity:.65}.rs-sp__note{display:block;margin-top:4px;font-size:1.2rem;opacity:.75}' +
    '.rs-sp__bar{position:relative;height:6px;background:rgba(var(--color-foreground),.12);margin:0 14px 0 2px}' +
    '.rs-sp__fill{position:absolute;left:0;top:0;bottom:0;background:rgb(var(--color-foreground));transition:width .3s ease}' +
    '.rs-sp__mark{position:absolute;top:50%;width:12px;height:12px;margin:-6px 0 0 -6px;border-radius:50%;background:rgb(var(--color-background));border:2px solid rgba(var(--color-foreground),.35)}' +
    '.rs-sp__mark.is-on{border-color:rgb(var(--color-foreground));background:rgb(var(--color-foreground))}' +
    '.rs-sp__mark b{position:absolute;top:13px;left:50%;transform:translateX(-50%);font-size:1.1rem;font-weight:600;font-style:normal;white-space:nowrap;opacity:.75}' +
    '.rs-sp.is-max .rs-sp__fill{background:var(--rs-accent,#ff5a1f)}' +
    '.rs-sp.is-max .rs-sp__mark.is-on{border-color:var(--rs-accent,#ff5a1f);background:var(--rs-accent,#ff5a1f)}' +
    '.rs-sp.is-max .rs-sp__msg strong,.rs-sp.is-max .rs-sp__mark b{color:var(--rs-accent,#ff5a1f);opacity:1}' +
    /* Product page: hide the "More payment options" link under the Shop Pay button */
    '.shopify-payment-button__more-options{display:none!important}' +
    /* DiscountYard cart widget: swap its default gold for the RigStrips button black and accent orange */
    '#coupons_stacker_add_button,.discountyard-apply-button{background:rgb(var(--color-button,17,17,17))!important;color:rgb(var(--color-button-text,255,255,255))!important}' +
    '.stack-discounts-applied-discount,.stack-discounts-applied-discount *,[dy-cart-item-discounted-price]{color:var(--rs-accent,#ff5a1f)!important}' +
    '.stack-discounts-applied-discount svg path{fill:currentColor!important}';

  function ensureCss() {
    if (document.getElementById('rs-sp-css')) return;
    var s = document.createElement('style');
    s.id = 'rs-sp-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function placeProgress(host, cls) {
    if (!host || !host.parentNode) return;
    var el = host.previousElementSibling;
    if (!el || !el.classList.contains('rs-sp')) {
      el = document.createElement('div');
      el.className = 'rs-sp ' + cls;
      el.setAttribute('aria-live', 'polite');
      host.parentNode.insertBefore(el, host);
    }
    if (stripN > 0) {
      var key = stripN + '|' + otherApplied + '|' + note;
      if (el.getAttribute('data-k') !== key) {
        el.innerHTML = progressHtml(stripN);
        el.setAttribute('data-k', key);
      }
      el.classList.toggle('is-max', stripN >= 4 && !otherApplied);
      el.hidden = false;
    } else if (!el.hidden) {
      el.hidden = true;
    }
  }

  function renderMessages() {
    if (stripN === null) return;
    document.querySelectorAll('[data-rs-strip-nudge]').forEach(function (el) {
      if (el.getAttribute('data-n') !== String(stripN)) {
        el.innerHTML = nudgeHtml(stripN);
        el.setAttribute('data-n', String(stripN));
      }
    });
    ensureCss();
    placeProgress(document.querySelector('cart-drawer-items'), 'rs-sp--drawer');
    placeProgress(document.getElementById('main-cart-items'), 'rs-sp--page');
  }

  function updateMessages(cart) {
    if (!cart || !cart.items) return;
    stripN = countStrips(cart);
    otherApplied = '';
    note = '';
    var losing = '';
    (cart.discount_codes || []).forEach(function (d) {
      if (isTierCode(d.code)) return;
      if (d.applicable !== false) { if (!otherApplied) otherApplied = d.code; }
      // Only welcome codes (RS-/RSW-) apply to strips, so only they can "lose" to the strip discount.
      // Other inactive codes (e.g. a bundle code with no bundle in the cart) get no message.
      else if (!losing && /^RSW?-/i.test(d.code)) losing = d.code;
    });
    // A code is on the cart but Shopify kept the strip discount because it saves more.
    var hasAuto = cart.items.some(function (i) {
      return (i.line_level_discount_allocations || []).some(function (a) {
        var t = a.discount_application && a.discount_application.title;
        return t && /^buy more, save more/i.test(t);
      });
    });
    if (losing && !otherApplied && hasAuto) {
      note = 'The strip discount saves you more than ' + losing + ', so it was applied instead. Codes can’t be combined.';
    }
    renderMessages();
  }

  var mo = null;
  function watch() {
    if (mo || !window.MutationObserver) return;
    var t = null;
    mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(renderMessages, 50);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  window.RsTiers = { check: check };

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { schedule(); }); } catch (e) {}
    }
    ensureCss();
    watch();
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
